import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { formatDate } from '../../../core';

@Component({
  standalone: false,
  selector: 'app-calendar-rescheduled',
  templateUrl: './calendar-rescheduled.component.html',
  styleUrls: ['./calendar.component-rescheduled.scss']
})
export class CalendarRescheduledComponent implements OnInit, OnChanges, OnDestroy {
  @Input() id: string;
  @Input() typeCall: string;
  @Input() value: Date;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() availableDates: string[];
  @Input() disabled = false;
  @Input() isLoading = false;
  @Input() dateError: string;
  @Input() opened = false;
  @Output() update = new EventEmitter<Date>();
  @Output() loadDates = new EventEmitter<boolean>();
  @ViewChild('picker1') private picker1: MatDatepicker<Date>;
  date = new FormControl(new Date());
  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    this.date.setValue(this.value);
    if (this.opened) {
      this.picker1.open();
    }
  }

  ngOnDestroy() {}

  myFilter = (d: Date): boolean => {
    const availableDates: string[] = this.availableDates;
    return availableDates && (!availableDates.length || availableDates.indexOf(formatDate(d)) !== -1 );
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.update.emit(event.value);
  }

  loadDatesAvailables() {
    if (this.availableDates && this.availableDates.length && this.availableDates.length === 1) {
      this.picker1.close();
      this.loadDates.emit(true);
    }
  }

  dateClass = (d: Date) => {
    if (!d || !this.availableDates || this.availableDates.length === 0) {

      return 'date-available';
    }

    const formatted = formatDate(d);
    const isAvailable = this.availableDates.indexOf(formatted) !== -1;


    const firstAvailable = this.availableDates[0];
    const [year, month] = firstAvailable.split('-').map(Number);
    const monthOfDate = d.getMonth() + 1;
    const yearOfDate = d.getFullYear();


    if (monthOfDate !== month || yearOfDate !== year) {
      return 'date-available';
    }

    if (isAvailable) {
      return 'date-available';
    } else {
      return 'date-unavailable';
    }
  }

}
